module.exports = __webpack_public_path__ + "static/parade-2020-house56-6899339fd79e988071737e3d2d09deb2.jpg";